import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'isomorphic-dompurify';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import { renderToStaticMarkup } from 'react-dom/server';
import parseHTMLString from '../common/customLinkParser';
import { ENVIRONMENT, styleVariables } from '../common/constants';
import logger from '../common/logger';
import EnvContext from '../common/envContext';

const HTML = ({ content }) => {
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];

  try {
    const parsedHTML = parseHTMLString({ html: DOMPurify.sanitize(content.body, { ADD_ATTR: ['target', 'rel'] }), env });

    // Validate that parsed nodes will render
    renderToStaticMarkup(
      parsedHTML,
    );

    return <Grid container><Grid lg={8} md={12} sm={12}><RootDiv className="html-unit-root-div">{parsedHTML}</RootDiv></Grid></Grid>;
  } catch (e) {
    logger.error(`Error in HTML parsing for content item: ${content.id} - `, e);
    return <Grid container><Grid lg={8} md={12} sm={12}><RootDiv dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.body, { ADD_ATTR: ['target', 'rel'] }) }} /></Grid></Grid>;
  }
};

const RootDiv = styled.div`

    h2{
      margin-bottom: 22px;
      font-size: 26px;
    }
    h3{
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
    }
      a[class*="MuiButton"] svg {
        stroke: ${styleVariables.inkOnBackground};
      }
      a[class*="MuiButton-contained"] svg {
        stroke: ${styleVariables.background};
      }
      @media screen and (max-width: 600px) {
        h2{
          font-size: 21px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
`;

HTML.propTypes = {
  content: PropTypes.shape({
    body: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
};

export default HTML;
